// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1GZgD","large":"styles_large__2Kfdi"};